export default __webpack_public_path__ + "static/media/book-logo.f3741250.svg";